// src/config.js
//Detect environment automatically
const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

export const API_BASE_URL = isLocal 
    ? "http://localhost:8000/api/v1" 
    : "https://api.airssecurity.com/api/v1";

export const APP_NAME = "AIRS Security | Autonomous AI Sentinel";